import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    name: 'admin',
    redirect: '/admin/dashboard',
    meta: {
      title: 'Админ-панель',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () => import('@/modules/admin/views/AdminDashboard.vue'),
    meta: {
      title: 'Дашборд',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/orders',
    name: 'admin-orders',
    component: () => import('@/modules/admin/views/AdminOrders.vue'),
    meta: {
      title: 'Управление заказами',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/payments',
    name: 'admin-payments',
    component: () => import('@/modules/admin/views/AdminPayments.vue'),
    meta: {
      title: 'Управление оплатами',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('@/modules/admin/views/AdminUsers.vue'),
    meta: {
      title: 'Управление пользователями',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/tools',
    component: () => import('@/modules/admin/views/AdminTools.vue'),
    name: 'admin-tools',
    meta: {
      title: 'Инструменты',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    // PRO-114: /admin/analytics больше не алиас AdminTools (PRO-66) - под этим
    // путём теперь настоящая аналитика (тренд GMV/заказов, топ поставщиков и
    // категорий), а не инструменты админа.
    path: '/admin/analytics',
    name: 'admin-analytics',
    component: () => import('@/modules/admin/views/AdminAnalytics.vue'),
    meta: {
      title: 'Аналитика',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/settings',
    redirect: {
      path: '/admin/dashboard',
      hash: '#settings',
    },
    meta: {
      title: 'Настройки',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/products',
    name: 'admin-products',
    component: () => import('@/modules/admin/views/ProductsView.vue'),
    meta: {
      title: 'Управление товарами',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/categories',
    name: 'admin-categories',
    component: () => import('@/modules/admin/views/CategoriesView.vue'),
    meta: {
      title: 'Управление категориями',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/units',
    name: 'admin-units',
    component: () => import('@/modules/admin/views/UnitsView.vue'),
    meta: {
      title: 'Единицы измерения',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/attributes',
    name: 'admin-attributes',
    component: () => import('@/modules/admin/views/AttributesView.vue'),
    meta: {
      title: 'Характеристики товаров',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/category-attributes',
    name: 'admin-category-attributes',
    component: () => import('@/modules/admin/views/CategoryAttributesView.vue'),
    meta: {
      title: 'Атрибуты категорий',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/admin/suppliers',
    name: 'admin-suppliers',
    component: () => import('@/modules/admin/views/AdminSuppliers.vue'),
    meta: {
      title: 'Управление поставщиками',
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
]
